import React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import ProductCard from '../components/ProductCard';
import { theme } from '../styles/theme';

const products = [
  {
    id: 1,
    name: 'Premium Water Tank 1000L',
    description: 'High-quality water storage solution',
    price: '₹15,000',
    image: '/images/tank1.jpg'
  },
  {
    id: 2,
    name: 'Stainless Steel Tank 500L',
    description: 'Durable and corrosion-resistant',
    price: '₹10,000',
    image: '/images/tank2.jpg'
  },
  {
    id: 3,
    name: 'Polyethylene Tank 2000L',
    description: 'Large capacity storage',
    price: '₹25,000',
    image: '/images/tank3.jpeg'
  }
];

const Products = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: theme.palette.background.default }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h2" component="h1" align="center" sx={{ color: theme.palette.primary.main }}>
          Our Products
        </Typography>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {products.map((product) => (
            <Grid item xs={12} md={4} key={product.id}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Products;